import { useState, useEffect } from "react";
import { formatCurrency } from '../../../../utils/FormatCurrency';
import InputLogin from '../../../inputs/InputLogin';
import InputSelectMethod from '../../../inputs/inputSelectMethod';
import ButtonWhite from '../../../button/ButtonWhite';
import { formatAmountForInput, capitalizeFullName } from '../../../../utils/Utils';
import ButtonSelect from '../../../button/ButtonSelect';

import COP from '../../../../assets/currency/copu.png'
import USD from '../../../../assets/currency/usd.png'

// Diccionario para traducir el código de banco a nombre
const bankCodeToName = {
    0: "Bancolombia",
    1: "Banco de Bogotá",
    2: "Banco Popular",
    3: "BBVA",
    4: "Colpatria",
    5: "Davivienda",
    6: "Banco AV Villas",
    7: "Banco Caja Social",
    8: "Banco Agrario",
    9: "Banco BCSC",
    10: "Banco Colmena",
    11: "Banco Coomeva",
    12: "Banco AV Villas",
    13: "Banco Falabella",
    14: "Banco Pichincha",
    15: "Bancoomeva",
    16: "Banco Santander",
    17: "Banco de Occidente",
    18: "Nequi",
    19: "Daviplata",
    20: "Movii"
};

const MultiSend = ({
    balanceWalletCop,
    loading,
    balanceWalletUsd,
    currency,
    setUsername,
    username,
    validateUser,
    users,
    setUsers,
    error,
    bankList = [],
    selectedBank,
    setSelectedBank,
    validateBankAccount,
    bankAccounts,
    setBankAccounts,
    handleAccountCreate,
    activeButtonMultiSend,
    setActiveButtonMultiSend,
}) => {

    // Permitir modo banco tanto para COP como para USD
    // if (currency !== 'COP' && activeButtonMultiSend !== 'usuario') {
    //     setActiveButtonMultiSend('usuario');
    // }

    const updateAmount = (id, value) => {
        if (activeButtonMultiSend === 'usuario') {
            setUsers(users.map(user => user.profile_id === id ? { ...user, amount: value } : user));
        } else {
            setBankAccounts(bankAccounts.map(account => account.id === id ? { ...account, amount: value } : account));
        }
    };

    const totalAmount = activeButtonMultiSend === 'usuario'
        ? users.reduce((sum, user) => sum + (parseFloat(user.amount) || 0), 0)
        : bankAccounts.reduce((sum, account) => sum + (parseFloat(account.amount) || 0), 0);

    const totalItems = activeButtonMultiSend === 'usuario' ? users.length : bankAccounts.length;

    // Función para obtener la lista de bancos en el formato correcto para InputSelectMethod
    const getBankList = () => {
        console.log("bankList", bankList);
        if (!Array.isArray(bankList) || bankList.length === 0) {
            return [];
        }
        console.log("currency", currency);
        if (currency === 'USD') {
            console.log("bankList", bankList);
            // Para USD, usar el formato de checkbooks
            return bankList.map(bank => ({
                ...bank,
                account_holder_name: bank.name || bank.account_holder_name,
                bank_name: bank.payment_method || bank.bank_name,
                account_number: bank.routing || bank.account || bank.account_number,
                account_type: bank.type || bank.account_type,
                pk: bank.account_id
            }));
        } else {
            // Para COP, usar el formato existente
            return bankList.map(bank => ({
                ...bank,
                account_holder_name: bank.account_holder_name,
                bank_name: bank.bank_name,
                account_number: bank.account_number,
                account_type: bank.account_type,
                pk: bank.pk
            }));
        }
    };

    useEffect(() => {
        if (activeButtonMultiSend === 'usuario') {
            // Limpiar lista de cuentas bancarias cuando se cambie a usuario
            setBankAccounts([]);
        } else if (activeButtonMultiSend === 'banco') {
            // Limpiar lista de usuarios cuando se cambie a banco
            setUsers([]);
        }
    }, [activeButtonMultiSend, setBankAccounts, setUsers]);

    return (
        <div className="flex h-full w-full">
            {/* Columna izquierda */}
            <div className="w-[300px] min-w-[250px]  p-4 rounded-lg mr-4 flex flex-col justify-start">
                {/* Card de saldo */}
                <div className="flex flex-col items-start gap-1.5 p-4 rounded-lg bg-[#2B2B33] mb-6">
                    <p className="text-left">Saldo disponible:</p>
                    <div className="flex flex-row gap-3 items-center">
                        <img alt="currency" src={currency === 'COP' ? COP : USD} width={24} height={20} />
                        <p className="font-semibold text-lg">{currency === "COP" ? formatCurrency(balanceWalletCop) : formatCurrency(balanceWalletUsd)} {currency}</p>
                    </div>
                </div>
                {/* Enviados recientemente */}

            </div>
            {/* Columna derecha */}
            <div className="flex-1 flex flex-col">
                {/* Mostrar los botones para COP y USD */}
                {(currency === 'COP' || currency === 'USD') && (
                    <div className="flex justify-center mb-4">
                        <ButtonSelect
                            activeButton={activeButtonMultiSend}
                            setActiveButton={setActiveButtonMultiSend}
                            label1="Enviar a usuario"
                            label2="Enviar a Banco"
                            button1="usuario"
                            button2="banco"
                        />
                    </div>
                )}
                {/* Fila superior: Input + Botón Agregar */}
                <div className="flex items-center gap-4 mb-4">
                    {/* Input y botón agregar */}
                    <div className="flex-1 flex items-center gap-2">
                        {(activeButtonMultiSend === 'usuario') ? (
                            <InputLogin
                                mt="10px"
                                onChange={(e) => setUsername(e)}
                                value={username}
                                placeholder={"Ingrese un usuario"}
                                error={error}
                                className="w-full"
                            />
                        ) : (
                            <InputSelectMethod
                                bank={selectedBank}
                                handleAccountCreate={handleAccountCreate}
                                data={getBankList()}
                                setBank={setSelectedBank}
                                selectMethod={null}
                                currency={currency}
                            />
                        )}
                        <ButtonWhite
                            label="Agregar"
                            onClick={activeButtonMultiSend === 'usuario' ? validateUser : validateBankAccount}
                            isDisabled={
                                loading ||
                                (activeButtonMultiSend === 'usuario' ? username === "" : !selectedBank || !Array.isArray(bankList) || bankList.length === 0)
                            }
                            loading={loading}
                        />
                    </div>
                </div>
                {/* Botones de usuario/banco y resto del contenido */}
                <div className="flex h-full justify-start flex-col">
                    <div className="border-l-2 border-r-2 border-t-2 border-[#2b2a32] rounded-tl-lg rounded-tr-lg h-full">
                        {/* Header de la tabla */}
                        <div className="flex px-4 py-2 border-b border-[#2b2a32] text-gray-400 text-sm font-semibold">
                            <div className="w-1/2">
                                {activeButtonMultiSend === 'usuario' ? 'Usuario' : 'Banco'}
                            </div>
                            <div className="w-1/2 text-right">
                                Cantidad/Monto
                            </div>
                        </div>
                        {/* Filas de la tabla */}
                        <div>
                            {activeButtonMultiSend === 'usuario' ? (
                                users.length > 0 ? users.map((user) => (
                                    <div key={user.id} className="flex px-4 py-2 border-b border-[#2b2a32] items-center">
                                        <div className="w-1/2 truncate text-white text-left">{user.name}</div>
                                        <div className="w-1/2 flex justify-end">
                                            <InputLogin
                                                numericOnly={true}
                                                formatValue={(value) => formatAmountForInput(value, ',')}
                                                onChange={(e) => updateAmount(user.profile_id, e)}
                                                value={user.amount}
                                                placeholder={"Monto"}
                                                error={user.amount !== "" ? currency === "COP" ? (user.amount < 10000) : user.amount < 10 : false}
                                            />
                                        </div>
                                    </div>
                                )) : <p className="px-4 py-2 text-gray-500">Aún no hay usuarios agregados</p>
                            ) : (
                                bankAccounts.length > 0 ? bankAccounts.map((account) => (
                                    <div key={account.id} className="flex px-4 py-2 border-b border-[#2b2a32] items-center justify-between">
                                        <div className="w-1/2 text-white text-left">
                                            {currency === 'USD' ? (
                                                // Para USD, mostrar información de checkbooks
                                                `${account.account_holder_name} - ${account.bank_name} *${account.account_number && account.account_number.length >= 4 ? account.account_number.slice(-4) : '----'}`
                                            ) : (
                                                // Para COP, mostrar información de bancos colombianos
                                                `${capitalizeFullName(account.account_holder_name)} - ${bankCodeToName[account.bank_name] || account.bank_name} ${account.account_type === 1 ? 'Ahorros' : 'Corriente'} *${account.account_number ? account.account_number.slice(-4) : '----'}`
                                            )}
                                        </div>
                                        <div className="w-1/2 flex justify-end">
                                            <InputLogin
                                                numericOnly={true}
                                                formatValue={(value) => formatAmountForInput(value, ',')}
                                                onChange={(e) => updateAmount(account.id, e)}
                                                value={account.amount}
                                                placeholder={"Monto"}
                                                error={account.amount !== "" ? currency === "COP" ? (account.amount < 10000) : account.amount < 10 : false}
                                            />
                                        </div>
                                    </div>
                                )) : <p className="px-4 py-2 text-gray-500">Aún no hay cuentas bancarias agregadas</p>
                            )}
                        </div>
                    </div>
                    <div className="flex w-full justify-end p-2 border-t-2 border-l-2 border-r-2 border-b-2 border-[#2b2a32] rounded-bl-lg rounded-br-lg">
                        <p>Total {activeButtonMultiSend === 'usuario' ? 'usuarios' : 'cuentas'}: <span>{totalItems}</span></p>
                        <p className="ml-2 mr-2">{" | "}</p>
                        <p>Total a enviar: <span>{formatCurrency(totalAmount)}</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MultiSend;
